module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"no_item_message":{"none":"レビューがありません。","filtered":"条件に合ったレビューがありません。"}}}')
  delete Component.options._Ctor
}
